import { veriffIDVDecisionResponseSchema } from "../../i9-everify";
import { getSSEBaseSchema } from "../getSSEBaseSchema";

export const onboardingServerEventsSchema = getSSEBaseSchema(
  veriffIDVDecisionResponseSchema
);
